import React, { FC } from "react";
import NewLayout from "@components/new-ui/Layout";
import HeaderImage from "@components/CaseStudyComponents/HeaderImage";
import Aside from "@components/CaseStudyComponents/Aside";
import About from "@components/CaseStudyComponents/About";
import Challenge from "@components/CaseStudyComponents/Challenge";
import Solution from "@components/CaseStudyComponents/Solution";
import Impact from "@components/CaseStudyComponents/Impact";
import RelatedCaseStudies from "@components/CaseStudyComponents/RelatedCaseStudies";
import ImageComponent from "@components/CaseStudyComponents/ImageComponent";
import Signup from "@components/CaseStudyComponents/Signup";
import Quote from "../../components/CaseStudyComponents/Quote";

const LivingStone: FC = () => {
    const RELATED_CASE_STUDIES = [
        {
            id: 1,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-2.png",
            tag: "Retail, D2C",
            title: "Sattvic Stores Reduced RTO by 10% within a month of using Gallabox..",
            link: "/case-study/sattvic-store",
            description:
                "Sattvic Stores by Kabir Innovations is an online retail marketplace selling organic health supplements, herbs, extracts, and more. They locally source ...",
        },
        {
            id: 2,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-3.png",
            tag: "HR & Professional Service",
            title: "Jobstars India Deployed a Multilingual Chatbot to Handle 60%..",
            link: "/case-study/jobstars-india",
            description:
                "Founded in 2002, Jobstars is one of the leading players in the Indian recruitment ecosystem. They believe in combining their passion for people with smart investments ...",
        },
    ];
    return (
        <NewLayout
            title="LivingStone Stays - Case Study | Gallabox"
            description="LivingStone Stays Relocated Their Communications From IVR to WhatsApp API with Gallabox’s Multi-Agent Shared Inbox, Thereby Streamlining Efficiency in Sales, Support and Marketing Workflows."
            canonical="https://gallabox.com/case-study/livingstone-stay"
        >
            <HeaderImage
                imagePath={"https://assets.gallabox.com/gb-home/case-study/livingstone-woods.png"}
                imageText={
                    "LivingStone Stays Relocated Their Communications From IVR to WhatsApp API with Gallabox’s Multi-Agent Shared Inbox, Thereby Streamlining Efficiency in Sales, Support and Marketing Workflows."
                }
            />

            <div className="max-w-6xl mx-auto flex flex-col sm:flex-row gap-8 px-5 sm:px-25 lg:px-32">
                <div className="basis-1/5 mx-auto ">
                    <Aside
                        data={[
                            {
                                title: "Company",
                                content: "LivingStone Stays",
                            },
                            {
                                title: "Industry",
                                content: "Travel & Tourism",
                            },
                            {
                                title: "Employees",
                                content: "10",
                            },
                            {
                                title: "Product Used ",
                                content: ["WhatsApp Chatbot", "Shared Team Inbox", "WhatsApp Broadcast", "Zoho Integration"],
                            },
                            {
                                title: "Business Initiated Conversations per Month",
                                content: "10k+",
                            },
                            {
                                title: "Website",
                                link: "https://livingstonestays.com/",
                                content: "livingstonestays.com",
                            },
                        ]}
                    />
                </div>
                <main className="basis-4/5">
                    <About
                        aboutLogo={"https://assets.gallabox.com/gb-home/case-study/livingstonelogo.png"}
                        aboutTitle={"LivingStone Stays"}
                        aboutContent={
                            "Founded in 2019, LivingStone Stays is revolutionising the way people spend their leisure time - making holidays a way of life. Their platform is a one-stop solution for discovering, planning and booking an experiential holiday."
                        }
                    />
                    <Challenge
                        challengeTitle={"Lack of a centralised multi-agent platform to collaborate with teams, oversee customer & property owner conversations."}
                        challengeList={[
                            "Team members lacked a centralised dashboard like inbox to access all customer, partner and property owner conversations to coordinate travel planning.",
                            "Agents used multiple phone numbers to assist in travel planning and there was confusion between the various end users on which number to contact.",
                            "Messages were manually drafted by agents, thereby taking more time and effort by team members.",
                            "The managerial team were unable to oversee all conversations carried out by sales, support and marketing teams.",
                            "IVR although providing a quick response rate was not intuitive enough for the team to acquire lead qualifying data.",
                        ]}
                    />
                    <ImageComponent caption={"Previous Communication Flow via IVR"} imagelink={"https://assets.gallabox.com/gb-home/case-study/livingstone1.png"} />
                    <Quote
                        quoteText={"“Our team's overall efficiency in communication with customers, partners and property owners has increased after using Gallabox.”"}
                        paddingx={"px-7 sm:px-10 lg:px-16"}
                    />
                    <Solution
                        solutionTitle={"LivingStone Stays shifted their communications from IVR to Gallabox’s WhatsApp Business APIs"}
                        solutionContent={""}
                        solutionData={[
                            "The collaborative, multi-agent login feature of Gallabox helped LivingStone Stay's agents to access customer, partner and property owner conversations under one single WhatsApp number. They shifted their communications from IVR to WhatsApp Business APIs to increase efforts taken by team members.",
                            "Gallabox created a rule-based chatbot to collect qualifying lead data so that agents could take over conversations more efficiently.",
                            "The WhatsApp template message creation streamlined their manual efforts to coordinate with the user and assist in travel planning. They have now created templates for all of their use cases across all verticals.",
                            "LivingStone Stays integrated their Zoho CRM with Gallabox to access and store their contacts to WhatsApp broadcast campaigns to a larger audience.",
                        ]}
                    />
                    <ImageComponent caption={"Now: Dynamic Communication Workflow via WhatsApp"} imagelink={"https://assets.gallabox.com/gb-home/case-study/livingstone2.png"} />
                    <Quote
                        quoteText={
                            "“Gallabox has significantly helped us in streamlining our entire communication with our partners and customers. As WhatsApp is the most common platform for communication these days, this makes Gallabox a very powerful tool! Through Gallabox, we were able to make WhatsApp a central communication channel for our company.”"
                        }
                        quoteBy={"- Chirag B,"}
                        position={"Founder of LivingStone Stays"}
                        paddingx={"px-7 sm:px-10 lg:px-16"}
                    />
                    <Impact
                        impactContent={[
                            ` <li class="content">
                            The increase in the team's ability to take ownership of multiple conversations resulted in an increase in direct bookings.
                        </li>`,
                            `<li class="content">
                        There was transparency in conversations between customers, partners and property owners, thereby providing managers with all the insights they required.
                        </li>`,
                            ` <li class="content">
                        The creation of multiple WhatsApp templates for various use cases saved manual agent efforts by two fold.
                        </li>`,
                            ` <li class="content">
                            One single number for communication with LivingStone Stays ensured zero confusion between end clients and partners.
                     </li>`,
                        ]}
                    />
                </main>
            </div>
            <Signup img="https://assets.gallabox.com/gb-home/case-study/Robot.png" content="Want similar results?" btn="Sign Up For A Free Trial" />
            <RelatedCaseStudies sectionDescription="Related Case Studies" related={RELATED_CASE_STUDIES} />
        </NewLayout>
    );
};

export default LivingStone;
